@if (!!env) {
  <div
    style="
      top: 10px;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding-top: 24px;
    "
  >
    <div [style]="style">
      {{
        env === "development"
          ? "DESENVOLVIMENTO"
          : env === "staging"
            ? "HOMOLOGAÇÃO"
            : ""
      }}
    </div>
  </div>
}
